import { LOCAL_STORAGE_KEY } from './preferences.service';

export const name = 'rnLocalPreferences';

export default function rnLocalPreferences() {
  let localPreferences = window.localStorage.getItem(LOCAL_STORAGE_KEY);
  if(localPreferences) {
    try {
      let parsed = JSON.parse(localPreferences);
      return parsed;
    } catch(e) {
      console.warn('Unable to parse preferences from local storage', localPreferences, e);
    }
  }
  return null;
}
